
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/penetration-testing",
      function () {
        return require("private-next-pages/penetration-testing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/penetration-testing"])
      });
    }
  